import { FC, HTMLAttributes } from 'react';
import { OneOrMoreReactElements } from '../../types';
import { joinClassNames } from '../../utils';
import { NavItem, NavItemProps } from './NavItem';
import styles from './styles.module.scss';

export type NavProps = HTMLAttributes<HTMLElement> & {
  children: OneOrMoreReactElements<NavItemProps>;
  variant?: 'default' | 'underlined';
};

type NavSubcomponents = {
  Item: typeof NavItem;
};

export const Nav: FC<NavProps> & NavSubcomponents = ({ children, variant = 'default' }) => (
  <nav>
    <ul className={joinClassNames(styles.nav, variant !== 'default' && styles[variant])}>{children}</ul>
  </nav>
);

Nav.Item = NavItem;
